"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Portal = void 0;
const react_1 = require("react");
const react_dom_1 = __importDefault(require("react-dom"));
const Portal = (props) => {
    const defaultNode = (0, react_1.useRef)(document.createElement('div'));
    (0, react_1.useEffect)(() => {
        if (!props.node) {
            document.body.appendChild(defaultNode.current);
        }
        return () => {
            if (defaultNode.current) {
                document.body.removeChild(defaultNode.current);
            }
        };
    }, [props.node]);
    const node = props.node || defaultNode.current;
    return react_dom_1.default.createPortal(props.children, node);
};
exports.Portal = Portal;
//# sourceMappingURL=Portal.js.map